import * as Html from "../util/Html.ts";
export {initDom}

Html.registerWidget('widget/accordion',{initDom:initDom})

function initDom(accordion: HTMLElement){
  const headerSelector = ".collapsible-header";
  const bodySelector =  ".collapsible-body";

  // Initialiser tous les corps d'accordéon
  const bodies = accordion.querySelectorAll<HTMLElement>(bodySelector);
  const headers = accordion.querySelectorAll<HTMLElement>(headerSelector);
  bodies.forEach(body => {
    body.style.boxSizing = 'border-box';
    body.style.overflow = 'hidden';
    body.style.height = '0px';
    body.style.transition = 'height 0.35s linear';

  });
  headers.forEach(header=>{
    var icon = header.querySelector<HTMLElement>('icon:last-child');
    if(icon) icon.style.transition = 'all 0.35s linear'
  })
  // Gérer les clics sur les en-têtes
  accordion.addEventListener('click', function(event){
    const target = event.target as HTMLElement;

    // Vérifier si le clic est sur un header ou dans un header
    const header = target.closest(headerSelector) as HTMLElement;
    if(!header || !accordion.contains(header)) return;

    // Trouver le body associé (élément suivant)
    const body = header.nextElementSibling as HTMLElement;
    if(!body || !body.matches(bodySelector)) return;

    if(header.classList.contains('accordion-open')){
      // Fermer l'accordéon actuel
      body.style.height = '0px';
      header.classList.remove('accordion-open');
      header.querySelector<HTMLElement>('icon:last-child')?.classList.remove('rotate180')

    }else{
      // Fermer tous les accordéons ouverts
      accordion.querySelectorAll('.accordion-open').forEach(openHeader => {
        openHeader.classList.remove('accordion-open');
        openHeader.querySelector<HTMLElement>('icon:last-child')?.classList.remove('rotate180')
      });

      // Fermer tous les corps
      bodies.forEach(b => {
        b.style.height = '0px';
      });

      // Ouvrir l'accordéon cliqué
      header.classList.add('accordion-open');
      header.querySelector<HTMLElement>('icon:last-child')?.classList.add('rotate180')
      body.style.display = 'block';
      body.style.height = body.scrollHeight + "px";
    }
  });
}